import ClientList from './ClientList.vue'
import ClientAdd from './CreateClient.vue'
import Clients from './Clients.vue'
import EditClient from './EditClient.vue'

export default {
  path: 'clients',
  component: Clients,
  children: [
    { path: '', component: ClientList },
    { path: 'create', component: ClientAdd },
    { path: ':id', component: EditClient }
  ],
  meta: { requiresAdminPermissions: true }
}
